import { gql } from '@apollo/client';

export const getJournalEntriesQuery = gql`
    query GetJournalEntries($take: Int, $orderBy: String, $startAtCreatedAt: DateTimeISO) {
        journalEntries(take: $take, orderBy: $orderBy, startAtCreatedAt: $startAtCreatedAt) {
            id
            text
            rating
            ritualId
            ritualType
            taskName
            promptText
            createdAt
        }
    }
`;
